module.exports = __webpack_public_path__ + "img/course_guide_2.af4a9ac6.png";